/**
 * Case management types
 * These types match the backend schema
 */

export enum CaseStatus {
  ACTIVE = 'active',
  CLOSED = 'closed',
  SUSPENDED = 'suspended',
}

export interface CaseDetail {
  case_reason?: string;
  case_level?: string;
  court_name?: string;
  court_contact?: string;
  case_summary?: string;
  fee_situation?: string;
  secondary_reason?: string;
  notes?: string;
}

export interface Case {
  id: number;
  case_number: string;
  case_name: string;
  case_type: string;
  case_stage?: string;
  case_status: CaseStatus;
  accept_date?: string;
  court_date?: string;
  verdict_date?: string;
  responsible_lawyer_id: number;
  responsible_lawyer_name?: string;
  assistant_lawyer_id?: number;
  assistant_lawyer_name?: string;
  creator_name?: string;
  created_by: number;
  created_at: string;
  updated_at?: string;
  details?: CaseDetail;
}

export interface CaseStatistics {
  total_cases: number;
  active_cases: number;
  closed_cases: number;
  suspended_cases: number;
  my_cases: number;
  as_responsible: number;
  as_assistant: number;
  this_month_new: number;  // 全局本月新增
  my_this_month_new: number;  // 我的本月新增
}
